import { render, staticRenderFns } from "./etapa_7.vue?vue&type=template&id=4789cb06&scoped=true&"
import script from "./etapa_7.vue?vue&type=script&lang=js&"
export * from "./etapa_7.vue?vue&type=script&lang=js&"
import style0 from "./etapa_7.vue?vue&type=style&index=0&id=4789cb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789cb06",
  null
  
)

export default component.exports